<template>
	<Button
		class="data-table-button"
		rounded
		text
		:icon="props.icon"
		:severity="props.severity"
		v-bind="$attrs"
		@click="emit('click', $event)" />
</template>

<script setup lang="ts">
import Button from 'primevue/button'

defineOptions({
	inheritAttrs: false,
})

const props = withDefaults(
	defineProps<{
		icon: string
		severity?: string
	}>(),
	{
		severity: 'secondary',
	},
)

const emit = defineEmits<{
	(e: 'click', event: MouseEvent): void
}>()
</script>

<style lang="scss" scoped>
.data-table-button {
	width: 30px !important;
	height: 30px !important;
	border-radius: 100% !important;
}
</style>
